import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { mapModeStore } from "./map-mode-store";

const authStore = new Vuex.Store({
  state: {
    token: "",
    rawToken: "",
    name: "",
    department: "",
    authLevel: 0,
    orgType: null,
    isGuest: true,
    first_login: false,
    invoiceAllowedFlag: 0,
  },
  mutations: {
    updateRespProfile(state, respData) {
      authStore.commit("updateName", respData.value.name);
      authStore.commit("updateDepartment", respData.value.department);
      if (respData.value.auth) {
        authStore.commit("updateAuthLevel", respData.value.auth);
      } else {
        authStore.commit("updateAuthLevel", respData.value.privilege);
      }
      authStore.commit("updateOrgType", respData.value.org_type);
      //   authStore.commit("updateMyAccount", respData.value);
      authStore.commit("updateIsGuest", false);
      authStore.commit("updateFirstLogin", respData.value.is_first_login);
      authStore.commit(
        "updateInvoiceAllowedFlag",
        respData.value.invoice_allowed_flag
      );
    },
    updateToken(state, token) {
      console.log(token, "Ajslashjjhkaskhjasjhkkhashjk")
      state.token = token;
      const tokenArray = token.split(" ");
      state.rawToken = tokenArray[1];
    },
    updateTokenFromParam(state, token) {
      if (state.token) {
        state.token = "Bearer " + token;
      } else {
        state.token = "Bearer " + token;
      }
      state.rawToken = token;
    },
    clearToken(state) {
      state.rawToken = "";
      state.token = "";
      state.isGuest = true;
      localStorage.removeItem("auth");
    },
    updateName(state, name) {
      state.name = name;
    },
    updateDepartment(state, department) {
      state.department = department;
    },
    updateAuthLevel(state, authLevel) {
      state.authLevel = authLevel;
    },
    updateOrgType(state, orgType) {
      state.orgType = orgType;
    },
    updateIsGuest(state, isGuest) {
      state.isGuest = isGuest;
    },
    updateFirstLogin(state, isLogin) {
      state.first_login = isLogin;
    },
    updateInvoiceAllowedFlag(state, invoiceAllowedFlag) {
      state.invoiceAllowedFlag = invoiceAllowedFlag;
    },
  },
  getters: {
    isAuthorized: (state) => state.token && state.token.length > 0,
    rawToken: (state) => state.rawToken,
    mapUrl: (state) => {
      //  alert("z" + mapModeStore.getters.mode + mapModeStore.getters.mapUrlOption)
      console.log(
        state.rawToken + mapModeStore.getters.mapUrlOption,
        "hagsashjgashjg"
      );
      return state.rawToken + mapModeStore.getters.mapUrlOption;
    },
    mapUrlOrikomi: (state) => {
      return state.rawToken + mapModeStore.getters.mapUrlOptionOrikomi;
    },
    authLevel: (state) => state.authLevel,
    firstLogin: (state) => state.first_login,
  },
  plugins: [
    createPersistedState({
      key: "auth",
    }),
  ],
});

export { authStore };
